export enum ClaimJourneyEntryPoint {
  AccountNewClaim = 'account-new-claim',
  AccountDraft = 'account-draft',
  ClaimLandingDraft = 'claim-landing-draft',
  ClaimLandingLoginless = 'claim-landing-loginless',
  ClaimLandingLoggedIn = 'claim-landing-logged-in',
  DirectLinkLoginless = 'direct-link-loginless',
  DirectLinkLoggedIn = 'direct-link-logged-in',
}

export interface IBWClaimsPortalMetrics {
  claimReference?: string;
  bookingID?: string;
  claimTypeName?: string;
  policyName?: string;
  partnerName?: string;
  partnerID?: string;
  subsidiaryName?: string;
  subsidiaryID?: string;
  policyTypeGroupName?: string;
}

export interface IBWClaimsJourneyTrackingArgs extends IBWClaimsPortalMetrics {
  claimJourneyID?: string | null;
  claimSelectorName?: string;
  decisionPointsName?: string;
  decisionPointsAnswer?: string;
  sectionName?: string;
  hasLeavedClaimJourney?: boolean;
  completed?: boolean;
  submitted?: boolean;
  xclaimValidationError?: unknown;
  fieldValidationErrorCount?: number;
  hasClickedHelpCenter?: boolean;
  hasClickedClaimSubmittedAlertLink?: boolean;
  hasClickedClaimSubmittedCopyURL?: boolean;
  hasClickedClaimSubmittedViewClaimButton?: boolean;
  documentName?: string;
  helpArticleSlug?: string;
  fileUploadErrors?: {
    code?: string;
    size?: number;
    type?: string;
  };
  entryPoint?: ClaimJourneyEntryPoint;
  variant?: string | null;
  isFirstSection?: boolean;
}

export interface IBWFNOLSectionTimeTrackingArgs extends IBWClaimsPortalMetrics {
  claimJourneyID?: string | null;
  timeSpent: number;
  claimTypeID?: string;
  entryPoint?: ClaimJourneyEntryPoint;
  sectionName?: string;
  documentName?: string;
  variant?: string | null;
  isFirstSection?: boolean;
}

export interface IBWFNOLSubmittedPageTimeTrackingArgs extends IBWClaimsPortalMetrics {
  timeSpent: number;
  variant?: string | null;
}

export interface IBWStoredClaimSelectorDataArgs {
  policyName: string;
  claimSelectorName: string;
  decisionPointsName: string;
  decisionPointsAnswer: string;
}

export interface IBWClaimsJourneyError {
  sectionName: string | null;
  fieldName: string | null;
  errorMessage: string;
}

export interface IBWClaimDetailsCommunicationsTrackingArgs extends IBWClaimsPortalMetrics {
  link: string;
  status?: string;
  dateSent?: string;
  linkText?: string;
  emailTemplateId?: string;
  emailTemplateSlug?: string;
}

export interface IBWRentalCoverBannerImpressionTrackingArgs {
  domID: string;
  CountryOfTravelCode: string;
  CustomerCountryCode: string;
  FromDate: string;
  ToDate: string;
  PolicyType: string;
  source?: string;
}

export interface IBWRentalCoverBannerClickTrackingArgs {
  bannerID: string;
  domID: string;
  CountryOfTravelCode: string;
  CustomerCountryCode: string;
  FromDate: string;
  ToDate: string;
  PolicyType: string;
  source?: string;
}

export interface IBWCallUsClickTrackingArgs {
  partnerSlug: string;
}

export interface IBWCESScoreTrackingArgs extends IBWClaimsPortalMetrics {
  source: string;
  score?: string;
  articleSlug?: string;
  feedback?: string;
  reviewed?: boolean;
}

export interface IBWContactModalTrackingArgs extends IBWClaimsPortalMetrics {
  contactJourneyID: string | null;
  bookingReference?: string;
  contactPurpose?: string;
  pageSlug?: string;
  articleTitle?: string;
  hasOpenedContactModal?: boolean;
  hasClosedContactModal?: boolean;
  hasClickedReturnPreviousStep?: boolean;
  hasClickedHaveMoreQuestionsButton?: boolean;
  hasClickedViewAllArticlesButton?: boolean;
  hasClickedSubmitEnquiryButton?: boolean;
  hasSubmitEnquirySuccessfully?: boolean;
}

export interface IBWQuickActionsTrackingArgs extends IBWClaimsPortalMetrics {
  quickActionLocation?: string;
  quickActionKey?: string;
}

export enum SelfServiceFlowEntryPoints {
  BookingCard = 'booking-card',
  QuickActions = 'quick-actions',
  ClaimsLanding = 'claims-landing',
  Email = 'email',
}

export enum SelfServiceLoginOrigin {
  SignUpSMS = 'sms',
  SignUpEmail = 'email',
}

export interface IBWSelfServiceTrackingArgs extends IBWClaimsPortalMetrics {
  loginFlowEntryPoint?: SelfServiceLoginOrigin;
  loginFlowCompleted?: boolean;
  claimFlowClaimsLandingCheckpoint?: boolean;
  claimFlowBookingCardCheckpoint?: boolean;
  claimFlowQuickActionsCheckpoint?: boolean;
  claimFlowLoginless?: boolean;
  claimFlowClaimSelectorCheckpoint?: boolean;
  claimFlowCompleted?: boolean;
  modifyFlowEntryPoint?: SelfServiceFlowEntryPoints;
  modifyFlowButtonCheckpoint?: boolean;
  modifyFlowCompleted?: boolean;
  cancelFlowEntryPoint?: SelfServiceFlowEntryPoints;
  cancelFlowButtonCheckpoint?: boolean;
  cancelFlowCompleted?: boolean;
  payoutFlowEntryPoint?: SelfServiceFlowEntryPoints;
  payoutFlowGetPaidButtonCheckpoint?: boolean;
  payoutFlowCompleted?: boolean;
}
